/**
 * Утилита для запросов к FastAPI.
 * Автоматически добавляет заголовок X-Init-Data из Telegram WebApp и часовой пояс.
 */

const API_BASE = process.env.REACT_APP_API_URL || '';

function getUserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return 'UTC';
  }
}

async function apiFetch(path, options = {}) {
  const initData = window.Telegram?.WebApp?.initData || '';
  const timezone = getUserTimezone();

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'X-Init-Data': initData,
      'X-Timezone': timezone,
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `HTTP ${response.status}`);
  }

  return response.json();
}

export const getPetCard = (petId) => apiFetch(`/api/pets/${petId}/card`);
export const getWeight = (petId, months) => apiFetch(`/api/pets/${petId}/weight?months=${months}`);
export const getCare = (petId) => apiFetch(`/api/pets/${petId}/care`);
export const getTreatments = (petId, months) => apiFetch(`/api/pets/${petId}/treatments?months=${months}`);
export const getNutritionStats = (petId, months) => apiFetch(`/api/pets/${petId}/nutrition/stats?months=${months}`);
export const getNutritionItems = (petId, months) => apiFetch(`/api/pets/${petId}/nutrition/items?months=${months}`);
export const getNutritionTreats = (petId, months) => apiFetch(`/api/pets/${petId}/nutrition/treats?months=${months}`);
export const getDietChanges = (petId) => apiFetch(`/api/pets/${petId}/nutrition/diet-changes`);
export const getSchedule = (petId) => apiFetch(`/api/pets/${petId}/schedule`);
export const getVetVisits = (petId, months) => apiFetch(`/api/pets/${petId}/vet-visits?months=${months}`);
export const getContacts = (petId) => apiFetch(`/api/pets/${petId}/contacts`);
export const getDocuments = (petId) => apiFetch(`/api/pets/${petId}/documents`);
export const getLabData = (petId) => apiFetch(`/api/pets/${petId}/lab`);
export const getPetSitterData = (petId) => apiFetch(`/api/pets/${petId}/petsitter`);
export const getRoutines = (petId) => apiFetch(`/api/pets/${petId}/routines`);
export const getMeds = (petId) => apiFetch(`/api/pets/${petId}/meds`);
export const getFoodReactions = (petId, months) => apiFetch(`/api/pets/${petId}/food-reactions?months=${months}`);
export const getStoolScale = (petId, months) => apiFetch(`/api/pets/${petId}/stool-scale?months=${months}`);
export const getSymptomScale = (petId, months) => apiFetch(`/api/pets/${petId}/symptom-scale?months=${months}`);
export const getFastingVomit = (petId, months) => apiFetch(`/api/pets/${petId}/fasting-vomit?months=${months}`);
export const getInflammation = (petId, { year, weekFrom, weekTo } = {}) => {
  const q = new URLSearchParams();
  if (year) q.set('year', year);
  if (weekFrom) q.set('week_from', weekFrom);
  if (weekTo) q.set('week_to', weekTo);
  const qs = q.toString();
  return apiFetch(`/api/pets/${petId}/inflammation${qs ? `?${qs}` : ''}`);
};
export const deleteDocument = (petId, docId) =>
  apiFetch(`/api/pets/${petId}/documents/${docId}`, { method: 'DELETE' });

export async function uploadDocument(petId, section, file) {
  const initData = window.Telegram?.WebApp?.initData || '';
  const form = new FormData();
  form.append('section', section);
  form.append('file', file);
  const response = await fetch(`${API_BASE}/api/pets/${petId}/documents`, {
    method: 'POST',
    headers: { 'X-Init-Data': initData },
    body: form,
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || `HTTP ${response.status}`);
  }
  return response.json();
}

export async function downloadPdf(path, filename) {
  const initData = window.Telegram?.WebApp?.initData || '';
  const timezone = getUserTimezone();
  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      'X-Init-Data': initData,
      'X-Timezone': timezone,
    },
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function initializeUserTimezone() {
  const timezone = getUserTimezone();
  localStorage.setItem('userTimezone', timezone);
  return timezone;
}

/**
 * Строит URL для файлового эндпоинта (PDF/документ) с init_data в query-параметре.
 * Позволяет открывать файл напрямую по ссылке без JS-обёртки.
 */
export function buildFileUrl(path, extraParams = {}) {
  const initData = window.Telegram?.WebApp?.initData || '';
  const params = new URLSearchParams({ init_data: initData, ...extraParams });
  return `${API_BASE}${path}?${params.toString()}`;
}
